import { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import PsContext from "../../../context";
import HeaderLayout1 from "./Header/headerLayout1";
import HeaderLayout2 from "./Header/headerLayout2";
import HeaderLayout3 from "./Header/headerLayout3";

const Header = () => {
  const context = useContext(PsContext);

  const helpLineMobile = context.settingValue("admission_support_mobile");
  const helpLineEmail = context.settingValue("admission_support_email");
  const admissionImg = context.settingValue("admission_img_width");
  const headerLayout =
    Number(context.settingValue("admission_header_layout")) || 1;

  const renderLayout = () => {
    const props = {
      admissionImg,
      helpLineMobile,
      helpLineEmail,
      context,
    };
    switch (headerLayout) {
      case 2:
        return <HeaderLayout2 {...props} />;

      case 3:
        return <HeaderLayout3 {...props} />;

      default:
        return <HeaderLayout1 {...props} />;
    }
  };

  return (
    <header
      className="header bg-white"
      style={{
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        borderBottom: "1px solid #eee",
      }}
    >
      <div className="bg-secondary-theme border-bottom border-white border-opacity-10">
        <div className="container-fluid py-1">
          <Row className="align-items-center g-0">
            <Col xs={12} md={4} className="d-none d-md-block">
              <span className="text-secondary-color fw-500 fs-11">
                <i className="fa-solid fa-graduation-cap me-1 opacity-75"></i>
                Admission for Academic Year{" "}
                {context.settingValue("current_academic_year")}
              </span>
            </Col>
            <Col xs={12} md={8} className="text-center text-md-end">
              <div
                className="text-secondary-color d-flex flex-wrap justify-content-center justify-content-md-end gap-2 gap-md-3"
                style={{ fontSize: "12px" }}
              >
                {helpLineMobile && helpLineMobile.length > 3 && (
                  <span className="fw-600">
                    <i className="fa-solid fa-phone me-1 opacity-75"></i>{" "}
                    {helpLineMobile}
                  </span>
                )}
                {helpLineEmail && helpLineEmail.length > 3 && (
                  <span className="fw-600">
                    <i className="fa-solid fa-envelope me-1 opacity-75"></i>{" "}
                    {helpLineEmail}
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="container-fluid py-md-1">
        <div className="row d-flex justify-content-center">
          <div className="col-11 py-4 py-sm-0">{renderLayout()}</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
